import React from 'react';
import PropTypes from 'prop-types';
import MobileTopNavSmallView from '../../MobileTopNav/MobileTopNavSmallView';

const BackMobileNavigationView = ({ label, onBack }) => (
  <div className="adv-workflows-back-mobile-navigation">
    <MobileTopNavSmallView
      className="adv-workflow-navigation-mobile-cancel-button"
      headerText={label}
      onClick={onBack}
    />
  </div>
);
BackMobileNavigationView.propTypes = {
  label: PropTypes.string.isRequired,
  onBack: PropTypes.func.isRequired,
};

export default BackMobileNavigationView;
